import { default as InstantWithdrawal } from './InstantWithdrawal.vue';
import { default as AgencyWithdrawal } from './AgencyWithdrawal.vue';
import { default as BankTransfer } from './BankTransfer.vue';
import { default as OnlineWithdrawal } from './OnlineWithdrawal.vue';
import { default as PscWithdrawal } from './PscWithdrawal.vue';

export {
    InstantWithdrawal,
    AgencyWithdrawal,
    BankTransfer,
    OnlineWithdrawal,
    PscWithdrawal,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/modules/userProfile/withdrawal/AccordionItems/index.ts